<template>
  <div class="bq-product-yyzs">
    <SectionTitle :title="'产品简介'" noSpacing></SectionTitle>
    <p class="title-desc">
      提供智慧用药服务，与院内数据整合，形成完整的用药闭环。主要包括用药提醒、用药记录和用药指南三个功能。
    </p>
    <div class="yyzs-descs">
      <InfoBox
        :col="3"
        :itemObj="item"
        v-for="item in datalist.desc"
        :key="item.advTitles"
      ></InfoBox>
    </div>
    <SectionTitle :title="'产品优势'" noSpacing></SectionTitle>

    <div class="yyzs-adv">
      <div class="adv-item" v-for="item in datalist.adv" :key="item.desc">
        <!-- <h3>{{ item.title }}</h3> -->
        <span>{{ item.desc }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import SectionTitle from '@/components/website_v3/SectionTitle';
import InfoBox from '@/components/website_v3/InfoBox';

export default {
  name: 'yyzs',
  data() {
    return {
      datalist: {
        adv: [
          {
            desc:
              '合理用药规则，包括配伍禁忌、累积用药剂量、单次用药记录、特殊人群等；',
          },
          {
            desc: '院内院外用药记录的打通，可查看全生命周期的用药情况。',
          },
        ],
        desc: [
          {
            iconUrl:
              'https://img.alicdn.com/tfs/TB17UicF.T1gK0jSZFhXXaAtVXa-80-90.png',
            advTitles: '用药提醒',
            advDesc:
              '用药提醒是患者可以手动录入药品及医嘱信息，设置提醒时间段。提醒患者按时服药，确保患者按医嘱进行服药，提高患者用药依从性。',
          },
          {
            iconUrl:
              'https://img.alicdn.com/tfs/TB14N5aF7L0gK0jSZFtXXXQCXXa-74-88.png',
            advTitles: '用药记录',
            advDesc:
              '用药记录，记录患者院内院外所有的用药信息，通过患者的用药记录，系统可以智能化提醒患者合理用药，包括药品的累积使用剂量、单次剂量和配伍禁忌等。',
          },
          {
            iconUrl:
              'https://img.alicdn.com/tfs/TB1c_sehsKfxu4jSZPfXXb3dXXa-74-96.png',
            advTitles: '用药指南',
            advDesc:
              '用药指南，包括药品说明书、相互作用、配伍禁忌，可以指导患者合理用药。',
          },
        ],
      },
    };
  },
  components: {
    SectionTitle,
    InfoBox,
  },
};
</script>
<style lang="less" scoped>
.bq-product-yyzs {
  .title-desc {
    color: #333;
    font-size: 18px;
  }

  .yyzs-adv {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .adv-item {
      width: 428px !important;
      padding: 20px;
      color: #fff;
      background-color: #014dba;
      border-radius: 4px;

      h3 {
        font-size: 20px;
      }

      span {
        font-size: 18px;
        font-weight: 300;
      }

      &:last-child {
        background-color: #045bd8;
      }
    }
  }

  .yyzs-descs {
    display: flex;
    justify-content: space-between;
    padding: 60px 0 90px;
    .bq-infobox {
      width: 252px !important;
    }
  }

  /deep/ .bq-infobox {
    p {
      font-size: 18px;
    }
  }

  /deep/ .header-title {
    margin-bottom: 60px;
    padding-bottom: 0;
  }
}
</style>
